import s from './helpers.module.css';
import { pushNotificationKey } from './local-storage';
import { swPath } from './path';

interface ValidateField {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rule: (value: any) => boolean;
}

// !!! ключ description занят в meta !!!

export const validate = (fields: Record<string, ValidateField>) => {
  let result = true;
  Object.keys(fields).forEach((key) => {
    const nameInputElement = document.querySelector(`[name="${key}"]`) as HTMLInputElement;
    const dataNameInputElement = document.querySelector(`[data-name="${key}"]`) as HTMLInputElement;
    const inputElement = nameInputElement || dataNameInputElement;
    const rule = fields[key].rule;

    if (inputElement) {
      const value = inputElement.value || inputElement.dataset.value;

      // Удалить предыдущие ошибки, если они есть
      const isErrorExist = inputElement.classList.contains(s.error);
      if (isErrorExist) {
        inputElement.classList.remove(s.error);
      }

      const isOk = rule(value);

      // Проверить значение поля
      if (!isOk) {
        result = false;
        inputElement.classList.add(s.error);
      }
    }
  });
  return result;
};

export const getPushState = () => {
  const isNotificationsOk = 'Notification' in window && Notification.permission === 'granted';
  const isPushesEnabled = !!localStorage.getItem(pushNotificationKey);
  return isNotificationsOk && isPushesEnabled;
};

export const getSwState = async () => {
  const sw = await navigator.serviceWorker.getRegistration(swPath);
  const isSwActive = sw && sw.active;
  return !!isSwActive;
};
